import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const enJsonContext = require.context('./en', false, /\.json$/);
const zhJsonContext = require.context('./zh', false, /\.json$/);

const enJsonObj = enJsonContext.keys().reduce((pre, fileName) => {
    pre[fileName] = enJsonContext(fileName);
    return pre;
}, {});
const zhJsonObj = zhJsonContext.keys().reduce((pre, fileName) => {
    pre[fileName] = zhJsonContext(fileName);
    return pre;
}, {});

const translation_en = Object.assign({}, ...Object.values(enJsonObj));
const translation_zh = Object.assign({}, ...Object.values(zhJsonObj));

const resources = {
    en: {
        translation: translation_en
    },
    zh: {
        translation: translation_zh
    }
};

const curLanguage = localStorage.getItem('SYSTEM_LANGUAGE') || 'zh';

i18n.use(initReactI18next).init({
    resources,
    lng: curLanguage,
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
